



























import { Component, Prop, Vue } from 'vue-property-decorator';
import Checkbox from '@/components/formComponents/core/Checkbox.vue';
import TextInput from '@/components/formComponents/core/TextInput.vue';
import { IFilter, IFilterGroup } from '../../../contract/search.contract';
import { Maybe } from '../../../shared/BasicTypes';

@Component({
  components: {
    Checkbox,
    TextInput,
  },
})
export default class FacetSearchFilterSelection extends Vue {
  @Prop()
  public filterGroup!: IFilterGroup;

  public openCloseState = false;

  public searchText: Maybe<string> = null;

  public created() {
    this.openCloseState = !this.filterGroup.collapsed;
  }

  public toggleOpen() {
    this.openCloseState = !this.openCloseState;
  }

  public onFilterTermChanged(filterGroup: string, filterTerm: string): void {
    this.$emit('filter-term-changed', filterGroup, filterTerm);
  }

  public get filteredOptions(): IFilter[] {
    const searchText = this.searchText?.trim().toLowerCase();
    return (
      (searchText && this.filterGroup.children.filter((c) => c.id.toLowerCase().includes(searchText))) ||
      this.filterGroup.children
    );
  }
}
